/** @format */

import { Grid } from '@material-ui/core';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { getKnowledgeBaseLink } from 'src/utils/helper';
import { KnowledgeBaseRating } from './rating';

export const KnowledgeBaseItem = ({ kb, item }) => {
  const { nid, title, date, category, content, rating } = item;
  return (
    <Link to={getKnowledgeBaseLink(kb, item)} className="knowledge_base-widget--list-item">
      <Grid className="knowledge_base-widget--list-item-top">
        <Grid className="knowledge_base-widget--list-item-date-title">
          <Grid className="knowledge_base-widget--list-item-title">{title}</Grid>
          <Grid className="knowledge_base-widget--list-item-date">
            {format(new Date(date * 1000), 'dd.MM.yyyy') || '00.00.0000'}
          </Grid>
        </Grid>
        {rating && rating !== 0 ? <KnowledgeBaseRating rating={rating} /> : null}
      </Grid>
      <Grid className="knowledge_base-widget--list-item-text">{content}</Grid>
    </Link>
  );
};
